import './GeneralInfoItem.css'
import { ReactNode } from 'react'

export function GeneralInfoItem({ label, value }: { label: string; value: ReactNode }) {
  return (
    <div className="general-info-item">
      <span className="general-info-item-label">{label}</span>
      {value}
    </div>
  )
}
